import { store } from '../../../../../resources/frontend/js/store/index';
import { prefillAddress } from '@mixins/form/prefill-address';
import { zipcodeIsAllowed } from '../../../../../resources/frontend/js/components/zipcode-lists';
import { prefillProvince } from '@mixins/form/prefill-province';
import { submitStep } from '@form/utils/submit';
import { validate } from '../../../js/vue-flows/default-components/sb-validate/v2/validate';
import sbPopup from '../../../mixins/utils/sb-popup';
import { validateFieldsViaAbstractApi } from '@form/utils/abstract-api-validation';

export const preValidateStep = async () => {
    if (store.state.form.attributes.cancelPreValidate) {
        store.state.form.attributes.cancelPreValidate = false;
        store.state.form.attributes.loading = false;
        return;
    }

    store.commit('cro/runBeforeFormSubmitEvents');

    const preValidated = preValidateFields();

    if (!preValidated) return;

    store.commit('form/setAttribute', {
        key: 'loading',
        value: true,
    });

    const abstractValidated = await validateFieldsViaAbstractApi();

    if (!abstractValidated) {
        store.commit('form/setAttribute', {
            key: 'loading',
            value: false,
        });

        return;
    }

    if (store.state.form.attributes.hiddenLoading) {
        setTimeout(() => {
            preValidateStep();
        }, 100);

        return;
    }

    // Check if there is a need for the address to be prefilled.
    const prefilledAddress = await prefillAddress();

    if (!prefilledAddress) {
        store.commit('form/setAttribute', {
            key: 'loading',
            value: false,
        });

        return;
    }

    prefillProvince();

    if (!zipcodeIsAllowed(store.state.user.location.zipcode)) {
        store.commit('form/setAttribute', {
            key: 'loading',
            value: false,
        });

        return;
    }

    submitStep();
};

export const preValidateFields = () => {
    const currentStep = store.state.form.attributes.step;
    let errors = false;

    for (const name of Object.keys(store.state.form.fields[currentStep])) {
        const valid = validate('form', name);
        store.commit('form/setFieldData', { name, key: 'preValidate', value: valid });
        store.commit('form/setFieldData', { name, key: 'validate', value: valid });

        if (!valid) {
            if (!errors) {
                sbPopup(store.state.page.notificationText, 'error', null, `#${name}`);
            }

            errors = true;
        }
    }

    return !errors;
};

export const validateField = (name, onlyPrevalidate = false) => {
    const valid = validate('form', name);
    store.commit('form/setFieldData', { name, key: 'preValidate', value: valid });

    if (!onlyPrevalidate) {
        store.commit('form/setFieldData', { name, key: 'validate', value: valid });
    } else {
        store.commit('form/setFieldData', { name, key: 'validate', value: null });
    }

    return valid;
};
